<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <b-link
      class="brand-logo"
      :to="{ name: 'Login' }"
    >
      <h2 class="brand-text text-primary ml-1">
        梦幻云平台
      </h2>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          页面走丢了
        </h2>
        <p class="mb-2">
          你访问的页面不存在或已被移除，请返回登录页重新进入。
        </p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          :to="{ name: 'Login' }"
        >
          返回登录页
        </b-button>

      </div>
    </div>
  </div>
<!-- / Error page-->
</template>

<script>
import { BLink, BButton } from 'bootstrap-vue'

export default {
  components: {
    BLink,
    BButton,
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';

.misc-wrapper {
  background: #fff;
}
</style>
